module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.cls
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: " arrow"
  })]), _vm._v(" "), _c('span', {
    class: _vm.iconClass()
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5b2024"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/side_panel_collection.vue
// module id = 1279
// module chunks = 1